var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefreshCw01 = function SvgRefreshCw01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.315 20.83a8.6 8.6 0 0 0 2.697-1.818 8.6 8.6 0 0 0 1.819-2.697Q20.5 14.77 20.5 13H19q0 2.925-2.038 4.963Q14.926 20 12 20t-4.962-2.037T5 13t2.037-4.962T12 6h.265L10.677 7.59l1.054 1.084 3.423-3.432-3.443-3.433-1.053 1.084L12.266 4.5H12q-1.77 0-3.315.67a8.6 8.6 0 0 0-2.697 1.819A8.6 8.6 0 0 0 4.17 9.685 8.3 8.3 0 0 0 3.5 13q0 1.77.67 3.315a8.6 8.6 0 0 0 1.819 2.697 8.6 8.6 0 0 0 2.696 1.819q1.545.67 3.315.67t3.315-.67"
  })));
};
export default SvgRefreshCw01;